module.exports = __webpack_public_path__ + "img/form-punch-image.f5c15cb0.png";